<template>
  <WdsButton v-bind="props">
    {{ text }}
  </WdsButton>
</template>

<script setup>
import { defineProps } from 'vue'
import { WdsButton } from '@worksome/wds-components'

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
})
</script>
